import React from 'react'

export const OrganizationDirectory = () => {
    return <div>OrganizationDirectory</div>
}
